const getRandomLower = () =>
  String.fromCharCode(Math.floor(Math.random() * 26) + 97);

const getRandomUpper = () =>
  String.fromCharCode(Math.floor(Math.random() * 26) + 65);

const getRandomNumber = () =>
  String.fromCharCode(Math.floor(Math.random() * 10) + 48);

const getRandomSymbol = () => {
  const symbols = "!@#$%^&*(){}[]=<>/,.";
  return symbols[Math.floor(Math.random() * symbols.length)];
};

export const generatePassword = (length) => {
  const generators = [
    getRandomLower,
    getRandomUpper,
    getRandomNumber,
    getRandomSymbol,
  ];

  // Guarantee one of each type
  const password = [
    getRandomLower(),
    getRandomUpper(),
    getRandomNumber(),
    getRandomSymbol(),
  ];

  // Fill the rest
  while (password.length < length) {
    const randomGenerator =
      generators[Math.floor(Math.random() * generators.length)];
    password.push(randomGenerator());
  }

  // Shuffle (Fisher-Yates)
  for (let i = password.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [password[i], password[j]] = [password[j], password[i]];
  }

  return password.join("");
};
